export enum ChatAnalyserLicenseProperty {
  FirstInstallationAt = 'first_installed_at',
}
